import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'src/app/shared/reports.service';
declare var $:any;
@Component({
  selector: 'app-career-modal',
  templateUrl: './career-modal.component.html',
  styleUrls: ['./career-modal.component.scss']
})
export class CareerModalComponent {
  @Input() selected_role: any = {};

  resetMessage = "";
  success_sent: boolean = false;
  enquiry_header = 'Enquiry';
  career_submit = {
    form_type: 'career',
    name: null,
    email: null,
    job_title:null,
    phone: null,
    location: null,
    message: ""
  };

  required_display_counter: number = 0;

  locations = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttarakhand',
    'Uttar Pradesh',
    'West Bengal',
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'Delhi NCR',
    'Lakshadweep',
    'Puducherry'
  ]

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private reportsService: ReportsService,
  ){

  }

  ngOnChanges(changes){
    if(changes && changes.selected_role && changes.selected_role.currentValue){
      console.log(changes);
      this.career_submit.job_title = this.selected_role.designation
    }
  }

  async submitRequest() {
    let fresh_data = {
      first_name: this.career_submit.name.substr(0, this.career_submit.name.indexOf(' ')),
      last_name: this.career_submit.name.substr(this.career_submit.name.indexOf(' ') + 1),
      email: this.career_submit.email,
      mobile_number: this.career_submit.phone,
      address: this.career_submit.location,
      job_title:this.career_submit.job_title,
      created_at: new Date().toISOString(),
    }

    // try {
    //   console.log('clicked');
    //   // this.login_spinner = true;
    //   let response = await this.reportsService.contactForDemo(this.career_submit).toPromise();
    //   if (response['code'] = '200') {
    //     // console.log(response);
    //     this.success_sent = true;
    //     this.career_submit = {
    //       form_type: 'demo',
    //       name: null,
    //       email: null,
    //       phone: null,
    //       job_title:null,
    //       location: null,
    //       message: ""
    //     };
    //   }
    // } catch (E) {
    //   console.log(E);
    // } finally {
    //   // this.login_spinner = false;
    // }
  }

  clearForm(form: NgForm) {
    this.career_submit = {
      form_type: 'demo',
      name: null,
      email: null,
      phone: null,
      job_title:null,
      location: null,
      message: ""
    };
    this.success_sent = false;
    form.reset();
  }

  isInvalid() {
    if (!this.career_submit.name || !this.career_submit.phone || !this.career_submit.email || !this.career_submit.location) {
      return true;
    }
  }

}
